// extracted by mini-css-extract-plugin
export default {"root":"dropdown-list_root__UpK8P","state":"dropdown-list_state__aOpuj","loading":"dropdown-list_loading__O3vQ5","placeHolderShimmer":"dropdown-list_placeHolderShimmer__0ZcO7"};